import { render, staticRenderFns } from "./CalServerListDetail.vue?vue&type=template&id=33c8ea17"
import script from "./CalServerListDetail.vue?vue&type=script&lang=js"
export * from "./CalServerListDetail.vue?vue&type=script&lang=js"
import style0 from "./CalServerListDetail.vue?vue&type=style&index=0&id=33c8ea17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports